import React, { Fragment } from 'react'
import { Button, Input, Select, SelectItem, Slider } from '@nextui-org/react'
import { inputs, creditYears, propertyCurrencies, pieCurrencies } from './constants'
import { handlePriceChange, handleKeyPress, handleSelectChange } from './controller'
import { formStyles } from './styles'
import PropTypes from 'prop-types'

const Form = ({ watch, register, setValue, errors, loading, handleSimulate, isDisabled }) => {
  const { anual_interest, credit_years } = watch()

  const haveSelect = ['property_value', 'pie_value']

  return (
    <form className={formStyles.MAIN_CONTAINER}>
      {inputs.map((input, index) => {
        if (input.name === 'credit_years') {
          const selected = { background: '#0084FE', color: 'white', border: '3px solid #0084FE' }
          return (
            <Fragment key={index}>
              <p className={formStyles.LABEL}>{input.label}</p>
              <div className="flex col-span-2 justify-evenly">
                {creditYears.map((year, index) => (
                  <div
                    key={index}
                    className={formStyles.CIRCLE}
                    style={credit_years === year ? selected : {}}
                    onClick={() => setValue('credit_years', year)}
                  >
                    <b>{year}</b>
                  </div>
                ))}
              </div>
            </Fragment>
          )
        }
        if (input.name === 'anual_interest') {
          return (
            <Fragment key={index}>
              <div className="flex col-span-2 font-bold text-primary">
                <p className="mr-auto">{input.label}</p>
                <p>{anual_interest}%</p>
              </div>
              <Slider
                label="Slider"
                step={0.1}
                maxValue={10}
                minValue={0}
                className={input.className}
                value={anual_interest}
                onChange={(value) => setValue('anual_interest', value)}
                defaultValue={anual_interest}
                showTooltip
                classNames={{
                  label: 'hidden',
                  value: 'hidden',
                }}
              />
            </Fragment>
          )
        }
        return (
          <Fragment key={index}>
            <p className={formStyles.LABEL}>{input.label}</p>
            <Input
              // label={input.label}
              type={input.type}
              name={input.name}
              className={input.className}
              color={errors[input.name] ? 'danger' : 'primary'}
              placeholder={input.placeholder}
              {...register(input.name)}
              errorMessage={errors[input.name]?.message}
              isRequired={input.isRequired}
              variant="bordered"
              aria-label="input"
              aria-labelledby="input"
              defaultValue={watch()[input.name]}
              onChange={(e) => handlePriceChange(input.name, e, setValue)}
              onKeyDown={(e) => handleKeyPress(input.name, e, setValue)}
              classNames={{
                label: 'hidden',
                inputWrapper: 'rounded-3xl ',
              }}
              endContent={
                haveSelect.includes(input.name) && (
                  <Select
                    items={input.name === 'property_value' ? propertyCurrencies : pieCurrencies}
                    onChange={(e) => handleSelectChange(e, input.name, setValue)}
                    defaultSelectedKeys={input.name === 'property_value' ? ['UF'] : ['%']}
                    className="w-28"
                    listboxProps={{ className: 'bg-background rounded-xl' }}
                    popoverProps={{ className: 'w-full' }}
                    classNames={{
                      base: '-mt-[3px]',
                      mainWrapper: '!h-[36px]',
                      value: '!h-[36px] !text-inactive !font-bold',
                      trigger: '!border-none',
                    }}
                    disallowEmptySelection
                    variant="bordered"
                    aria-label="select"
                    aria-labelledby="select"
                  >
                    {(option) => <SelectItem key={option.value}>{option.label}</SelectItem>}
                  </Select>
                )
              }
            />
          </Fragment>
        )
      })}
      <div className="flex justify-center w-full col-span-2 mt-6">
        <Button
          type="submit"
          color="primary"
          size="lg"
          className="font-bold rounded-3xl"
          variant="shadow"
          isLoading={loading}
          isDisabled={isDisabled}
          onClick={() => handleSimulate()}
        >
          Ver resultados
        </Button>
      </div>
    </form>
  )
}

Form.propTypes = {
  watch: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  handleSimulate: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
}

export default Form
